import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/header.js';

import { joinClasses } from 'utils/utils';

import Button from 'components/bolt/button/button';

import s from 'components/bolt/header/header.sss';

export default class Header extends BaseComp.default {

	renderPersistentButton() {
		let main = super.renderPersistentButton(...arguments);
		if (!this.props.isCalendarRemindMode) {
			return main;
		}
		const { appData, headerData } = this.props;
		const { showtimesOverlay, homeEntOverlay } = headerData;

		let hide = showtimesOverlay || homeEntOverlay;
		return (
			<div class={s.persistentButtonGroup}>
				{main}
				<Button
					class={joinClasses(s.persistentBtn, hide && s.hide, appData?.styling?.fontVariables?.headerCta)}
					trigger={this.showShowtimes}
					type="floating"
					ariaLabel={appData.copy.accessibilityCopy.$FIND_CINEMAS_BTN_ARIA}
					key="extra-showtimes"
				>
					Get NY and LA Tickets
				</Button>
			</div>
		);
	}

}
